import { clusterLabelStyle, clusterStyle } from './style';

export default (map: any, source = 'geojson') => {
  map.addLayer(Object.assign(
    {
      source,
      id: 'cluster',
      type: 'circle',
      filter: ['==', 'cluster', true],
    },
    clusterStyle,
  ));

  map.addLayer(Object.assign(
    {
      source,
      id: 'cluster_label',
      type: 'symbol',
      filter: ['==', 'cluster', true],
    },
    clusterLabelStyle,
  ));
};
